/** <huna-compare>: a native range input reveals the "with" layer. Without JS both slots stay visible, stacked. */
class HunaCompare extends HTMLElement {
  connectedCallback() {
    const range = this.querySelector('input[type="range"]');
    if (!range || 'enhanced' in this.dataset) return;
    const text = this.dataset.valueText || '%value%%';
    const set = () => {
      this.style.setProperty('--pos', `${range.value}%`);
      range.setAttribute('aria-valuetext', text.replace('%value%', range.value));
    };
    range.hidden = false;
    range.addEventListener('input', set);
    this.dataset.enhanced = '';
    set();
  }
}

if (!customElements.get('huna-compare')) customElements.define('huna-compare', HunaCompare);
